import { z } from 'zod';
import { agreementsSchema, requestIdSchema, timestampSchema, agreementResponseType, providerType, } from '@repo/shared/types';
export var agreementSharedRequestBodySchema = z.object({
    requestId: requestIdSchema,
    apiProvider: providerType,
    agreements: agreementsSchema,
});
// Response code 200
export var agreementSharedSuccessResponseBodySchema = z.object({
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: agreementResponseType,
    data: z.object({
        agreements: agreementsSchema,
    }),
});
// Response code 400
export var agreementSharedRedisKeyNotFoundResponseBodySchema = z.object({
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: agreementResponseType,
    data: z.object({
        errorDescription: z.string(),
    }),
});
// Response code 409 - Agreement for provider exists
export var conflictResponseBodySchema = z.object({
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: agreementResponseType,
    data: z.object({
        errorDescription: z.string(),
    }),
});
// Response code 500 - Unexpected exception
export var internalServerErrorResponseBodySchema = z.object({
    requestId: z.null(),
    timestamp: timestampSchema,
    type: z.null(),
    data: z.object({
        errorDescription: z.string().default('Unexpected exception.'),
    }),
});
